import ajax from "../lib/ajax";

class NotificationService {
  async createCsv(
    listname,
    userId,
    createDate,
    tags,
    userGroup,
    date,
    filters
  ) {
    try {
      const queryString = JSON.stringify(filters);
      const response = await ajax.get(
        `/create-csv?listname=${listname}&userId=${userId}&createDate=${createDate}&tags=${tags}&userGroup=${userGroup}&date=${date}&filters=${queryString}`
      );

      return response.data;
    } catch (err) {
      console.log(err);
    }
  }
  async createExcel(
    listname,
    userId,
    createDate,
    tags,
    userGroup,
    date,
    filters
  ) {
    try {
      const queryString = JSON.stringify(filters);
      const response = await ajax.get(
        `/create-excel?listname=${listname}&userId=${userId}&createDate=${createDate}&tags=${tags}&userGroup=${userGroup}&date=${date}&filters=${queryString}`
      );

      return response.data;
    } catch (err) {
      console.log(err);
    }
  }

  async downloadDetails(userId) {
    try {
      const response = await ajax.get(
        `/download-details?userId=${JSON.stringify(userId)}`
      );

      return response.data;
    } catch (err) {
      console.log(err);
    }
  }
  async deleteDownloadDetails(id) {
    try {
      const response = await ajax.get(
        `/delete-details?id=${JSON.stringify(id)}`
      );

      return response.data;
    } catch (err) {
      console.log(err);
    }
  }
  async getCount(userId) {
    try {
      const response = await ajax.get(
        `/download-count?userId=${JSON.stringify(userId)}`
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }

  async downloadCsv(id, listname) {
    while (true) {
      try {
        const response = await ajax.get(
          `/download-csv?id=${JSON.stringify(id)}&listname=${listname}`,
          { responseType: "blob" }
        );

        if (response.status === 200) {
          const blob = new Blob([response.data], { type: "application/csv" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${listname}.csv`;
          link.click();
          return response.data;
        }
      } catch (err) {
        console.log("CSV download failed, retrying...", err);
      }

      await new Promise((res) => setTimeout(res, 1000));
    }
  }

  async downloadExcel(id, listname) {
    while (true) {
      try {
        const response = await ajax.get(
          `/download-csv?id=${JSON.stringify(id)}&listname=${listname}`,
          {
            responseType: "blob",
          }
        );

        if (response.status === 200) {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${listname}.xlsx`;
          link.click();
          return response.data;
        }
      } catch (err) {
        console.log("Excel download failed, retrying...", err);
      }

      await new Promise((res) => setTimeout(res, 1000));
    }
  }
}
const notificationService = new NotificationService();
export default notificationService;
